export let CmsAltMenuGroup;(function(a){a.EditorList="editor-list",a.EditorImageMarkers="editor-image-markers"})(CmsAltMenuGroup||(CmsAltMenuGroup={}));